<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="门店：" prop="name" class="auto-width">
                <el-input v-model="filterForm.name" class="w120" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="状态：" prop="status">
                <el-select v-model="filterForm.status" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="启用" value="0"></el-option>
                  <el-option label="停用" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>
        <el-button type="primary" class="btn-add-block" @click="handleAdd">添加门店</el-button>

        <!-- table -->
        <div class="table-region last-text-align-right" v-loading="tableLoading">
          <el-table size="small" :data="tableData" ref="multipleTable" @selection-change="handleTableSelectionChange">
            <el-table-column type="selection" width="42" :selectable="checkSelectable"></el-table-column>
            <el-table-column label="门店">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="电话">
              <template slot-scope="scope">
                <p>{{ scope.row.tel }}</p>
              </template>
            </el-table-column>
            <el-table-column label="地址">
              <template slot-scope="scope">
                <p>{{ scope.row.address }}</p>
              </template>
            </el-table-column>
            <el-table-column label="添加时间" sortable sort-by="createDate">
              <template slot-scope="scope">
                <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
              </template>
            </el-table-column>
            <el-table-column label="总预约" sortable sort-by="price">
              <template slot-scope="scope">
                <p>{{ scope.row.orderNum || '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="总成交" sortable sort-by="price">
              <template slot-scope="scope">
                <p>{{ scope.row.dealNum || '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <!-- <el-switch v-model="scope.row.status" :inactive-value="CLOSE" :active-value="OPEN" active-color="#43B034" inactive-color="#D4D4DC" @change="handleSwitch(scope)"></el-switch> -->

                <el-popover placement="left" width="160" v-model="scope.row.statusVisible"
                  popper-class="confirm-popover">
                  <p>确定{{ scope.row.status === 0 ? '停用' : '启用' }}该门店？</p>
                  <div>
                    <el-button size="small" type="default" plain @click="scope.row.statusVisible = false">取消</el-button>
                    <el-button size="small" type="primary" :loading="statusLoading"
                      @click="handleSwitch(scope)">确定</el-button>
                  </div>
                  <div slot="reference" class="switch-wrapper" @click="handleSwitchClick">
                    <el-switch :value="scope.row.status" @change="handleSwitchChange(scope.row, scope.$index, $event)"
                      :inactive-value="1" :active-value="0" active-color="#43B034" inactive-color="#D4D4DC" />
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="handleEdit(scope)">编辑</el-button>

                <el-popover v-if="checkSelectable(scope.row)" placement="left" width="160"
                  v-model="scope.row.deleteVisible" popper-class="confirm-popover">
                  <p>确定删除该门店？</p>
                  <div>
                    <el-button size="small" type="default" plain @click="scope.row.deleteVisible = false">取消</el-button>
                    <el-button size="small" type="primary" :loading="deleteLoading"
                      @click="handleDelete(scope.row, scope.$index)">确定</el-button>
                  </div>
                  <el-button slot="reference" size="small" type="text">删除</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate">
            <el-checkbox v-model="allSelect" @change="handleAllSelectChange">全选当页</el-checkbox>

            <div class="button-wrap">
              <!-- 删除 -->
              <!-- 无预约&成交，账号停用后可删；有预约&成交不能删，前台会报错，需要将复选框disable -->
              <el-popover placement="top" width="165" v-model="operate.deleteVisible" popper-class="confirm-popover">
                <p>确定删除该门店？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus"
                    :loading="operateLoading">确定</el-button>
                </div>

                <el-button size="small" type="default" plain slot="reference">删除</el-button>
              </el-popover>
            </div>
          </div>


          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>

      </section>
</template>

<script>
import { COMMON, serviceShopList, serviceShopOpStatus, serviceShopDelete } from '../../../common/api';

export default {
  data() {
    return {
      COMMON,
      filterForm: {
        name: '', // 员工名字
        status: '' // 状态
      },
      tableLoading: false,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0
      },

      OPEN: 1, // 启用
      CLOSE: 0, // 关闭

      statusLoading: false,
      deleteLoading: false,

      multipleSelection: [], // 选中的数据
      allSelect: false, //全选当页
      operate: {
        deleteVisible: false // 删除
      },
      operateLoading: false
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * [getList description] 获取列表
     * @return {[type]}          [description]
     */
    getList: function () {
      this.tableLoading = true;

      let param = {
        'name': this.filterForm.name,
        'status': this.filterForm.status === '' ? null : parseFloat(this.filterForm.status),
        'pageNo': this.page.current,
        'pageSize': this.page.size
      }

      serviceShopList(param).then(res => {
        this.tableLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.page.total = data.total;

          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.tableLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [handleTableSelectionChange description] table筛选选中状态变化
     * @param  {[type]} val [description] 选中行的数据集合array
     * @return {[type]}     [description]
     */
    handleTableSelectionChange: function (val) {
      if (val.length < this.tableData.length) {
        // 未全选中，改变底部全选状态
        this.allSelect = false;
      } else {
        this.allSelect = true;
      }

      this.multipleSelection = val;
    },
    /**
     * [handleAllSelectChange description] 全选
     * @param  {[type]} selected [description]
     * @return {[type]}          [description]
     */
    handleAllSelectChange: function (selected) {
      this.$refs.multipleTable.toggleAllSelection();
    },
    checkSelectable(row) {
      return !(row.dealNum > 0 || row.orderNum > 0) && row.status == 1
    },
    /**
     * [handleOperateCancle description] 操作popover - 取消
     * @return {[type]} [description]
     */
    handleOperateCancle: function () {
      this.operate = {
        deleteVisible: false
      }
    },
    /**
     * [handleUpdateStatus description] 删除
     * @param  {[type]} status [description]
     * @return {[type]}        [description]
     */
    handleUpdateStatus: function () {
      let statusName = '删除';
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择需要' + statusName + '的门店');
        this.handleOperateCancle();
        return false;
      }

      this.operateLoading = true;

      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        ids.push(this.multipleSelection[i].id);
      }

      let params = {
        shopIds: ids.join(',')
      }

      serviceShopDelete(params).then(res => {
        this.operateLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: statusName + '成功', type: 'success' });
          this.multipleSelection = [];
          this.handleOperateCancle();
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.operateLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [handleAdd description] 新增
     * @return {[type]}     [description]
     */
    handleAdd: function () {
      this.$router.push('/service/store/add');
    },
    /**
     * [handleEdit description] 编辑
     * @param  {[Object]} scope [description] 当前操作列的对象
     * @return {[type]}     [description]
     */
    handleEdit: function (scope) {
      this.$router.push({ path: '/service/store/add', query: { id: scope.row.id, row: scope.row } });
    },
    /**
     * [handleDelete description] 删除员工
     * @param  {[Object]} scope [description] 当前操作行
     * @return {[type]}          [description]
     */
    handleDelete: function (row, index) {
      this.deleteLoading = true;
      var params = {
        shopIds: row.id,
      };
      serviceShopDelete(params).then(res => {
        this.deleteLoading = false;
        if (res.code == 0) {
          this.$message({ message: '删除成功', type: "success" });
          this.getList();
        } else {
          this.$message({ message: res.msg, type: "error" });
        }
      }).catch(error => {
        this.deleteLoading = false;
        this.$message.error('服务器异常');
      })
    },
    /**
     * [handleSwitch description] 启用和禁用
     * @param  {[Object]} scope [description] 当前操作行
     * @return {[type]}          [description]
     */
    handleSwitch: function (scope) {
      let param = {
        'shopId': scope.row.id,
        'status': scope.row.status === 1 ? 0 : 1
      }

      this.updateStatus(param);
    },
    updateStatus: function (param) {
      this.statusLoading = true
      serviceShopOpStatus(param).then(res => {
        let { code, data, msg } = res;
        this.statusLoading = false
        if (code == 0) {
          this.$message.success('操作成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.statusLoading = false
        this.$message.error('服务器异常');
      });
    },
    handleSwitchChange(row, index, e) {
      // console.log(row, index, e)
    },
    handleSwitchClick(e) {
      e.stopPropagation();
    }
  }
}
</script>

<style lang="scss" scoped>
// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;

.btn-add-block {
  // flex-shrink: 0;
  align-self: flex-start;
  margin-bottom: 20px;
}

// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;


  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;


  ::v-deep .el-table {
    // flex: 1;

    &::before {
      height: 0;
    }

  }

  // 修复固定列头部背景色不一致问题
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f6f7f9; // $colorTitleBg 的值，或者直接写变量如果可用
    border-bottom: none;
  }

  ::v-deep .el-table__fixed-right {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }

  // .table-footer {
  //   flex-shrink: 0; // 分页区域不压缩，保持固定高度
  // }
}
</style>
